/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, computed } from '@angular/core';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { SendMessageService } from 'src/chatbot/service/sendMessage.service';

@Component({
  selector: 'recommended-messages',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './recommendedMessages.component.html',
  styleUrl: './recommendedMessages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendedMessagesComponent {
  public dataChat = inject(DataChatService)
  public sendMessage = inject(SendMessageService)

  handleClick(message: string){
    // Send it like a typed message (not silent) so the clicked CTA text shows
    // as a user bubble in the conversation, mirroring what the user did.
    this.sendMessage.sendMessageWebSocket(message);
  }

 }